import { render, staticRenderFns } from "./StarterFooter.vue?vue&type=template&id=208626be&"
import script from "./StarterFooter.vue?vue&type=script&lang=js&"
export * from "./StarterFooter.vue?vue&type=script&lang=js&"
import style0 from "./StarterFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports